import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export const ContactForm = () => {
  const blank = { name: "", email: "", subject: "", message: "" };
  const [form, setForm] = useState(blank);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent! We'll get back to you within 1–2 business days.");
      setForm(blank);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="contact-form" className="space-y-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="ct-name" className="text-xs font-bold uppercase tracking-widest">Name</Label>
          <Input id="ct-name" data-testid="contact-name-input" required value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="rounded-none h-12 border-ink/20 focus-visible:ring-flame" placeholder="Your name" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="ct-email" className="text-xs font-bold uppercase tracking-widest">Email</Label>
          <Input id="ct-email" type="email" data-testid="contact-email-input" required value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="rounded-none h-12 border-ink/20 focus-visible:ring-flame" placeholder="you@email.com" />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="ct-subject" className="text-xs font-bold uppercase tracking-widest">Subject</Label>
        <Input id="ct-subject" data-testid="contact-subject-input" value={form.subject}
          onChange={(e) => setForm({ ...form, subject: e.target.value })}
          className="rounded-none h-12 border-ink/20 focus-visible:ring-flame" placeholder="What's this about?" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="ct-message" className="text-xs font-bold uppercase tracking-widest">Message</Label>
        <Textarea id="ct-message" data-testid="contact-message-input" required value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          className="rounded-none border-ink/20 focus-visible:ring-flame min-h-[130px]"
          placeholder="Ask us anything — trips, packages, group size, bringing a friend..." />
      </div>
      <Button type="submit" disabled={loading} data-testid="contact-submit-btn"
        className="bg-ink hover:bg-ink/90 text-cream rounded-none h-12 px-10 font-bold uppercase tracking-[0.2em] text-xs transition-transform hover:-translate-y-0.5">
        {loading ? "Sending..." : "Send Message"}
      </Button>
    </form>
  );
};
